import { Col, Divider, Image, Row, Typography } from 'antd';
import clsx from 'clsx';

import styles from '../../index.module.less';
import './header.less';
import { simplifyEmbedCode } from '../Video';
import { useContextReports } from '../../../../../context/reports';

const Header = () => {
  const { report, form } = useContextReports();
  const isVideoSectionActive = form?.getFieldValue(['reportView', 'vidoeWalk', 'active']);

  return (
    <>
      <div id="loanInformation">
        <Row gutter={[20, 20]} style={{
          width: '100%',
          background: '#f8f8f8',
          borderRadius: '30px',
          padding: '24px',
          margin: 0,
        }}
        >
          <div className="p-inline-10 flex-row gap-8 flex-align-center">
            <div className={clsx(styles.imageWrapper, 'd-m-none')}>
              <Image
                preview={false}
                src={report?.User?.avatar || '/avatar-placeholder.png'}
                alt="User Avatar"
                height={120}
                width={120}
              />
            </div>
            <div className={clsx(styles.imageWrapper, 'd-m-flex d-lg-none')}>
              <Image
                preview={false}
                src={report?.User?.avatar || '/avatar-placeholder.png'}
                alt="User Avatar"
                height={52}
                width={52}
              />
            </div>
          </div>
          <Col style={{ marginRight: 'auto' }} md={12} span={24}>
            <div className="flex-col gap-20">
              <Row gutter={[20, 20]}>
                <Col md={12} span={24}>
                  <div className="flex-col gap-8">
                    <Typography.Title level={4} className="color-gray uppercase">
                      Loan Officer
                    </Typography.Title>
                    <Typography.Text
                      className="fs-1"
                      style={{
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal',
                        display: 'block',
                      }}
                    >
                      {report?.User?.firstName} {report?.User?.lastName}
                    </Typography.Text>

                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="flex-col gap-8">
                    <Typography.Title level={4} className="color-gray uppercase">
                      Phone
                    </Typography.Title>
                    <Typography.Text className="fs-1">{report?.User?.phoneNumber || '-'}</Typography.Text>
                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="flex-col gap-8">
                    <Typography.Title level={4} className="color-gray uppercase">
                      Email
                    </Typography.Title>
                    <Typography.Text
                      className="fs-1"
                      style={{
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal',
                        display: 'block',
                      }}
                    >
                      {report?.User?.email || '-'}
                    </Typography.Text>

                  </div>
                </Col>
                <Col md={12} span={24}>
                  <div className="flex-col gap-8">
                    <Typography.Title level={4} className="color-gray uppercase">
                      NMLS License
                    </Typography.Title>
                    <Typography.Text className="fs-1">{report?.User?.nmlsId || '-'}</Typography.Text>
                  </div>
                </Col>
              </Row>
              <Row gutter={[20, 20]}>
                <Col md={12} span={24}>
                  <div className="flex-col gap-8">
                    <Typography.Title level={4} className="color-gray uppercase">
                      Address
                    </Typography.Title>
                    <Typography.Text className="fs-1">{report?.User?.address || '-'}</Typography.Text>{' '}
                  </div>
                </Col>
                {report?.User?.companyNmlsId && (
                  <Col md={12} span={24}>
                    <div className="flex-col gap-8">
                      <Typography.Title level={4} className="color-gray uppercase">
                        Company NMLS License
                      </Typography.Title>
                      <Typography.Text className="fs-1">{report.User.companyNmlsId}</Typography.Text>{' '}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </Col>



          <div className='flex flex-row gap-20 videoWrapper'>
            <div
              className="p-inline-10 flex-col flex-justify-space-between companyWrapper"
            >
              <Image
                preview={false}
                src={report?.User?.logo || '/logo.png'}
                alt="Company Logo"
                height={75}
                style={{ objectFit: 'contain' }}
                id='companyLogo'
              />
              <Image
                preview={false}
                style={{ objectFit: 'contain' }}
                height={60}
                src={`/${report?.User?.settings_logo || 'ComplianceLogoType1.png'}`}
              />
            </div>
            {report?.video && isVideoSectionActive && (
              <div className='videoEmbed' >
                <div dangerouslySetInnerHTML={{ __html: simplifyEmbedCode(report?.video || '') }} />
              </div>
            )}
          </div>

        </Row>
      </div>
      <Divider />
    </>
  );
};

export default Header;
